import { CustomHeader } from 'components/universal/custom-header';
import { useTranslation } from 'react-i18next';
import { SetNewPasswordView } from 'views/set-new-password';

export const SetNewPassword = () => {
    const { t } = useTranslation('', {
        keyPrefix: 'SEO.setNewPassword',
    });

    return (
        <div>
            <CustomHeader title={t('title')} />
            <SetNewPasswordView />
        </div>
    );
};
